import { FiatCurrency } from '@quickbit/qb-design-system';

export interface Settlement {
  euroAmount: number;
  euroFee: number;
  euroCustomerFee: number;
}

export type OrderStatus =
  | 'COMPLETED'
  | 'PENDING'
  | 'NOTICED'
  | 'CANCELLED'
  | 'REFUNDING'
  | 'PARTIALLY_REFUNDED'
  | 'REFUNDED';

export const ORDER_STATUS: Record<OrderStatus, boolean> = {
  COMPLETED: true,
  PENDING: true,
  NOTICED: true,
  CANCELLED: true,
  REFUNDING: true,
  REFUNDED: true,
  PARTIALLY_REFUNDED: true,
};

export const ORDER_STATUS_OPTIONS = Object.keys(ORDER_STATUS).map(
  (k) => k as OrderStatus
);

export interface OrderError {
  createdAt: Date;
  errorCode: string;
  details: Record<string, unknown>;
}

export interface OrderCallback {
  createdAt: Date;
  requestBody: Record<string, unknown>;
  ok: boolean | null;
  responseContent: string | null;
}

export interface Merchant {
  uuid: string;
  name: string;
}

export interface Order {
  uuid: string;
  referenceId: string | null;
  userId: string | null;
  amount: number;
  creationAmount: number;
  currency: FiatCurrency;
  createdAt: Date;
  completedAt: Date | null;
  externalStatus: OrderStatus;
  settlement: Settlement | null;
  useOnrampFlow: boolean;
  useProcessingFlow: boolean;
  errors: OrderError[];
  extraData: Record<string, unknown>;
  merchant: Merchant;
  callbacks: OrderCallback[];
  callbackUrl: string | null;
  hasUserData: boolean | null;
}

export type OrderType = 'PAY' | 'PROCESSING' | 'ONRAMP';

export const SupportedCorporateWalletCryptoCurrencies = [
  { label: 'USD Coin', value: 'USDC' },
];
